(() => {
  'use strict';
  if (window.KensuiProductMarks) return;

  const registered = /^(?:EZ[\s‐‑–-]?VEST|NANO[\s‐‑–-]?BARS)$/i;
  const names = /\b(?:EZ[\s‐‑–-]?(?:VEST|MACE|BOOT|BELL|CLACE|CLUB|HELM|NECK|ROPE)|NANO[\s‐‑–-]?BARS|DUO[\s‐‑–-]?(?:RINGS|BELT)|SWISSIES(?:[\s‐‑–-](?:SP|S|P|N|X))?|ADAPTABELL|360°[\s-]?GRIPS|SWVL(?:360)?|ASCENT|ARX|HYDROPLATES?|YINYANG|POPEYES|CHROMAFORGE|VERSAPLATES|TORII|REVO[\s-]RACK|TENSIONFLEX|CENTURION|PIVOT|KABUTO|SAKURA|SHIRO|OSAKA|TOKYO|KYOTO|OKINAWA|SAPPORO|KOBE|TOYAMA|BEPPU|BACK[\s-]BLASTER|BARBARIAN|LANDMINE[\s-]ARSENAL|TARZAN[\s-]10|WOODY)(?![\p{L}\p{N}])([®™]?)/giu;
  const selector = [
    '.template-product h1', '.ks-pdp-product-subtitle', '.ks-pdp-sticky__title',
    '.product-single__title', '.product-card__title', '.list-view-item__title',
    '.ksu-tile__name', '.ksu-itemacc__name', '.ksu-stripitem__name',
    '.ksu-mrow__name', '.ksu-search__name', '.ksu-acctab',
    '.kc-item-name', '.kc-bundle-name', '.kc-plate-name', '.kc-upsell-name',
    '.cart__product-title', '.cart__product-name',
    '.ks-card__title', '.ksa-card__title', '.ksb__feature-name', '.ksb-card__name',
    '.kh-banner__title', '.kh-sw__name', '.kh-bars__name', '.kh-bs__name',
    '.kh-best__name', '.kh-title', '.kph__title'
  ].join(',');

  function format(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement.closest('.ks-product-mark,script,style,.ksu-itemacc__badge')
          ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const text = node.nodeValue;
      const matches = [...text.matchAll(names)];
      if (!matches.length) continue;
      const fragment = document.createDocumentFragment();
      let cursor = 0;
      let changed = false;
      for (const match of matches) {
        const next = node.nextSibling;
        if (match.index + match[0].length === text.length &&
            next?.nodeType === Node.ELEMENT_NODE &&
            (next.classList.contains('ks-product-mark') || /^[®™]$/.test(next.textContent.trim()))) continue;
        const existing = match[1];
        const brand = existing ? match[0].slice(0, -1) : match[0];
        fragment.append(document.createTextNode(text.slice(cursor, match.index) + brand));
        const mark = document.createElement('sup');
        mark.className = 'ks-product-mark';
        mark.textContent = existing || (registered.test(brand) ? '®' : '™');
        fragment.append(mark);
        cursor = match.index + match[0].length;
        changed = true;
      }
      if (changed) {
        fragment.append(document.createTextNode(text.slice(cursor)));
        node.replaceWith(fragment);
      }
    }
  }

  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(selector)) format(root);
    root.querySelectorAll(selector).forEach(format);
  }

  window.KensuiProductMarks = { refresh: scan };
  scan(document.body);
  const observer = new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) {
      const element = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
      const title = element.closest?.(selector);
      if (title) roots.add(title);
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('ks-product-mark')) roots.add(node);
      }
    }
    observer.disconnect();
    roots.forEach(scan);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
